import { Message, Step } from "element-ui";

import Time_range from '../assets/js/TimeRange'
import router from "../router";
import {
    login,
    refresh,
    getUserInfo,
    postWechatLogin,
    getPublicStaticAll,
    postLogout,
    // getAmazonAdvStaticAll,
    getOaStaticAll,
} from "../request";
const common = {
    state: {
        token: localStorage.getItem("token") || "",
        name: "",
        isAdmin: false,
        userInfo: null,
        permissions: [],
        shopDetail: {},
        TimeRange: Time_range,
        // navDataGroup: [
        //     ...window.base_navDataGroup
        // ],
        // navDataGroup_office: [
        //     ...window.base_navDataGroup_office
        // ],
        // navDataGroup_hr: [
        //     ...window.base_navDataGroup_hr
        // ],
        // navDataGroup_system: [
        //     ...window.base_navDataGroup_system
        // ],
        navData: [],
        permissionsNav: [],
        // 消息通知数据
        notice: [],
        my_reviews: [],
        todos: [],
        notice_length: 0,
        wechatRandom: null,
        globalButtonStatus: true,
        selectUserList: [],
        activeModuldData: '',
        currentPath: '',
        activeModule: '',
        permissionsPath: [],
        _permissions: [],
        approvalStatic: {},
        bank_info: [],
        publicStaticAll: {},
        adStaticAll: {},
        oaStaticAll: {},
        set_activeModuldDataStat: [],
        activeModuldDataStat: '',
        titleData: {},
    },
    mutations: {
        SET_OA: (state, oaStaticAll) => { //oa公共静态属性
            state.oaStaticAll = oaStaticAll;
        },
        SET_AD: (state, adStaticAll) => { //AD公共静态属性
            state.adStaticAll = adStaticAll;
        },
        SET_PSA: (state, publicStaticAll) => { //新公共静态属性
            state.publicStaticAll = publicStaticAll;
        },
        SET_TOKEN: (state, token) => {
            state.token = token;
        },
        SET_AS: (state, approvalStatic) => { //审批的公共静态属性
            state.approvalStatic = approvalStatic;
        },
        SET_NAME: (state, data) => {
            state.name = data.name;
            state.userInfo = data;
            state.isAdmin = data.is_admin === 1;
        },
        SET_PERMISSIONS: (state, permissions) => {
            state.permissions = permissions;
        },
        set_activeModuldData: (state, data) => {
            state.activeModuldData = JSON.parse(data)
        },
        set_activeModuldDataOffice: (state, data) => {
            state.activeModuldDataOffice = JSON.parse(data)
        },
        set_activeModuldDataStat: (state, data) => {
            state.activeModuldDataStat = JSON.parse(data)
        },
        set_activeModuldDataHR: (state, data) => {
            state.activeModuldDataHR = JSON.parse(data)
        },
        set_currentPath: (state, path) => {
            state.currentPath = path
        },
        set_activeModule: (state, names) => {
            state.activeModule = names
        },
        set_titleData: (state, data) => {
            state.titleData = data
        },
    },
    actions: {
        //广告静态属性
        async AdStatic ({ commit, state }) {
            const res = await getAmazonAdvStaticAll()
            if (res.error === 0) {
                state.adStaticAll = res.data
                commit("SET_AD", res.data);
            } else {
                Message.error(res.message);
            }
        },
        //公用静态属性
        async publicStatic ({ commit, state }) {
            const res = await getPublicStaticAll()
            if (res.error === 0) {
                state.publicStaticAll = res.data
                commit("SET_PSA", res.data);
            } else {
                Message.error(res.message);
            }
        },
        //Oa静态
        async oaStatic ({ commit, state }) {
            const res = await getOaStaticAll()
            if (res.error === 0) {
                state.oaStaticAll = res.data
                commit("SET_OA", res.data);
            } else {
                Message.error(res.message);
            }
        },
        // 登录
        Login ({ commit }, userInfo) {
            return new Promise((resolve, reject) => {
                login(userInfo)
                    .then(res => {
                        if (res.error === 0) {
                            localStorage.setItem(
                                "token",
                                res.data.authorization
                            );
                            if (!!localStorage.getItem("loginTimes")) {
                                localStorage.setItem("loginTimes", 0)
                            }
                            commit("SET_TOKEN", res.data.authorization);
                            resolve(res);
                        } else {
                            if (!localStorage.getItem("loginTimes")) {
                                localStorage.setItem("loginTimes", 1)
                            } else {
                                let _num = Number(localStorage.getItem("loginTimes")) + 1
                                localStorage.setItem("loginTimes", _num)
                            }
                            // Message.error(res.message);
                            resolve(res);
                        }
                    })
                    .catch(error => {
                        // localStorage.setItem("codeImg", error.data.captcha_img)
                        reject(error);
                    });
            });
        },
        WeChatLogin ({ commit }, code) {
            return new Promise((resolve, reject) => {
                postWechatLogin({
                    code: code
                })
                    .then(res => {
                        if (res.error === 0) {
                            localStorage.setItem(
                                "token",
                                res.data.authorization
                            );
                            commit("SET_TOKEN", res.data.authorization);
                            resolve();
                        } else {
                            Message.error(res.message);
                            setTimeout(() => {
                                window.location.href =
                                    "https://" +
                                    window.location.hostname +
                                    "/#/login";
                            }, 500);
                        }
                    })
                    .catch(error => {
                        reject(error);
                        setTimeout(() => {
                            window.location.href =
                                "https://" +
                                window.location.hostname +
                                "/#/login";
                        }, 500);
                    });
            });
        },
        Refresh ({ commit }) {
            return new Promise((resolve, reject) => {
                refresh().then(res => {
                    if (res.error === 0) {
                        localStorage.setItem("token", res.data.authorization);
                        commit("SET_TOKEN", res.data.authorization);
                        resolve();
                    } else {
                    }
                }).catch(error => {
                    commit("SET_NAME", "");
                    commit("SET_PERMISSIONS", []);
                    commit("SET_TOKEN", "");
                    sessionStorage.clear();
                    // localStorage.clear();
                    Object.keys(localStorage).forEach(item => {
                        if (item.indexOf('token') !== -1 || item.indexOf('LogOut') !== -1) {
                            localStorage.removeItem(item)
                        }
                    })
                    router.push({ path: '/login' })
                    reject(error);
                });
            });
        },
        // 获取用户信息
        GetInfo ({ commit, state }) {
            return new Promise((resolve, reject) => {
                getUserInfo()
                    .then(response => {
                        const data = response.data;
                        let permission = data.permission;
                        state.bank_info = data.bank_info
                        // 权限处理
                        if(permission.some(v=>v == 'module-intellectual-property' ||  v=='module-talent') && permission.every(v=>v != 'module-tiktok-sale')) permission.push('module-tiktok-sale');
                        if(permission.some(v=> v=='module-business')&& permission.every(v=>v != 'module-oa-project')) permission.push('module-oa-project');
                        // let _flag = data.warehouse_permission;
                        commit("SET_PERMISSIONS", permission);
                        commit("SET_NAME", data);
                        localStorage.setItem("locale", data.language);
                        state._permissions = permission
                        localStorage.setItem(
                            "_permissions",
                            JSON.stringify(permission)
                        );
                        localStorage.setItem("userData", JSON.stringify(data));

                        localStorage.setItem(
                            "indexPath",
                            /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent) ? "/transIndex" : "/home/adminHome"
                        );
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        // 前端 登出
        FedLogOut ({ commit }) {
            return new Promise(resolve => {
                postLogout().then(res => {
                    commit("SET_NAME", "");
                    commit("SET_PERMISSIONS", []);
                    commit("SET_TOKEN", "");
                    sessionStorage.clear();
                    // localStorage.clear();
                    Object.keys(localStorage).forEach(item => {
                        if (item.indexOf('token') !== -1 || item.indexOf('LogOut') !== -1) {
                            localStorage.removeItem(item)
                        }
                    })

                    // router.push({ path: '/dev_login' })
                    window.location.href = '/#/dev_login';
                    localStorage.setItem("LogOut", 0)
                    resolve();
                })

            });
        },
        async getPermissionsPath ({ dispatch, commit, state }, url) {
            let permissionsPath = []
            state.permissionsPath = []
            let userData = JSON.parse(localStorage.getItem('userData'))
            let _permissions = JSON.parse(localStorage.getItem('_permissions'))
            const basePath = [
                '/home',
                '/login',
                '/home/tiktok/test',
            ] //basePath提供暂无或不需要权限名称的页面使用
            const basePath2 = [
                '/home/taskManagement/task_list',
                '/home/taskManagement/personal_task_management',
            ]
            if (userData.id == 1) {
                basePath.push(
                    '/home/systemManagement/interface',
                    '/home/systemManagement/external'
                )
            }
            //类似/home/approvalMangement/Approval_list?type=pending的地址  需要把/home/approvalMangement/Approval_list放到basePath2
        },
        changeSideNav ({ commit, state }, url) {

        },
        //防止请求未执行完毕重复点击按钮
        //参照组件：clothes_edit2
        globalButtonStatus ({ state }, _status) {
            state.globalButtonStatus = _status;
        }
    }
};

export default common;
